import { DATA_PROTECTION_ACTION_TYPE } from "./data-protection.action";

export const DATA_PROTECTION_MESSAGE_CONTEXT = {
	getGdprEnabledCountries: DATA_PROTECTION_ACTION_TYPE.getGdprEnabledCountries,
};
